<template>
  <div class="mian-article">
      <Header/>
      <div class="width1200">
        <h1>{{ $t('about.Contactus') }}</h1>
        <img src="~@/assets/image/aboutUs/address.png" alt="img">
        <div class="info" style="display: inline-block;margin-right: 105px">
          <span>{{ $t('product.Contact') }}：</span>
          <span>任洪凯</span>
        </div>
        <div class="info" style="display: inline-block">
          <span>{{ $t('product.Mail') }}：</span>
          <span>renhongkai@sml-zhuhai.cn</span>
        </div>
        <div class="info">
          <span>{{ $t('DataSubmission.ContactAddress') }}：</span>
          <span>{{ $t('footer.Address2') }}</span>
        </div>
<!--          <div class="row-info">-->
<!--              <div class="contact-site">-->
<!--                  <p class="t">{{ $t('about.GeneralManagementDepartment') }}</p>-->
<!--                  <p>-->
<!--                      <span class="iconfont icon-dianhua-yuankuang"></span>{{ $t('DataSubmission.telephone') }}：0756-3923598-->
<!--                  </p>-->
<!--                  <p>-->
<!--                      <span class="iconfont icon-youxiang"></span>{{ $t('product.Mail') }}：zhb@sml-zhuhai.cn-->
<!--                  </p>-->
<!--              </div>-->
<!--              <div class="contact-site">-->
<!--                  <p class="t">{{ $t('about.TechnologyDevelopmentDepartment') }}</p>-->
<!--                  <p>-->
<!--                      <span class="iconfont icon-dianhua-yuankuang"></span>{{ $t('DataSubmission.telephone') }}：0756-3923456-->
<!--                  </p>-->
<!--                  <p>-->
<!--                      <span class="iconfont icon-youxiang"></span>{{ $t('product.Mail') }}：kjfz@sml-zhuhai.cn-->
<!--                  </p>-->
<!--              </div>-->
<!--          </div>-->
<!--          <div class="row-info">-->
<!--              <div class="contact-site">-->
<!--                  <p class="t">{{ $t('about.HumanResourceDepartment') }}</p>-->
<!--                  <p>-->
<!--                      <span class="iconfont icon-dianhua-yuankuang"></span>{{ $t('DataSubmission.telephone') }}：0756-3923270-->
<!--                  </p>-->
<!--                  <p>-->
<!--                      <span class="iconfont icon-youxiang"></span>{{ $t('product.Mail') }}：nfhyhr@sml-zhuhai.cn-->
<!--                  </p>-->
<!--              </div>-->
<!--              <div class="contact-site">-->
<!--                  <p class="t">{{ $t('about.FinancialAssetsDepartment') }}</p>-->
<!--                  <p>-->
<!--                      <span class="iconfont icon-dianhua-yuankuang"></span>{{ $t('DataSubmission.telephone') }}：0756-3923967-->
<!--                  </p>-->
<!--                  <p>-->
<!--                      <span class="iconfont icon-youxiang"></span>{{ $t('product.Mail') }}：czb@sml-zhuhai.cn-->
<!--                  </p>-->
<!--              </div>-->
<!--          </div>-->
<!--          <div class="row-info">-->
<!--              <div class="contact-site">-->
<!--                  <p class="t">{{ $t('about.CooperationandExchangeDepartment') }}</p>-->
<!--                  <p>-->
<!--                      <span class="iconfont icon-dianhua-yuankuang"></span>{{ $t('DataSubmission.telephone') }}：0756-3923759-->
<!--                  </p>-->
<!--                  <p>-->
<!--                      <span class="iconfont icon-youxiang"></span>{{ $t('product.Mail') }}：collab@sml-zhuhai.cn-->
<!--                  </p>-->
<!--              </div>-->
<!--              <div class="contact-site">-->
<!--                  <p class="t">{{ $t('about.PlatformFacilitiesDepartment') }}</p>-->
<!--                  <p>-->
<!--                      <span class="iconfont icon-dianhua-yuankuang"></span>{{ $t('DataSubmission.telephone') }}：0756-6841943-->
<!--                  </p>-->
<!--                  <p>-->
<!--                      <span class="iconfont icon-youxiang"></span>{{ $t('product.Mail') }}：ptssb@sml-zhuhai.cn-->
<!--                  </p>-->
<!--              </div>-->
<!--          </div>-->
      </div>
      <Footer/>
  </div>
</template>

<script>
import Header from "@/components/Header"
import Footer from "@/components/Footer"
export default {
    components:{
        Header,
        Footer
    },
    data(){
        return {

        }
    }
}
</script>

<style scoped lang="scss">
    .mian-article{
        @include home_bg_t2_color();
        .width1200{
            width: 1000px;
            margin: 0 auto;
            padding: 50px 0;
            padding-bottom: 200px;
          >img{
            border-radius: 4px;
            display: inline-block;
            margin-bottom: 20px;
            color: rgba(16, 16, 16, 100);
            font-family: SourceHanSansSC-regular;
          }
          .info{
            font-size: 14px;
          }
            @include co_white_to_black();
            h1{
                text-align: center;
            }
            p{
                margin: 24px 0;
                
            }
            .t{
                font-size: 18px;
                font-weight: 600;
            }
            .row-info{
                display: flex;
                justify-content: space-between;
                border-bottom: 1px dashed #3a8cdd ;
            }
            .contact-site{
                width: 300px;
                .iconfont{
                    margin-right: 8px;
                    color: #3a8cdd;
                }
            }
        }
    }
</style>